import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { EColors, EFonts, EShadows } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    iconName: IconName;
    title: string;
    subtitle: string;
    buttonText?: string;
    buttonAction?: () => void;
    className?: string;
}

export const IconTextButtonBlock = (props: Props): JSX.Element => {
    return (
        <S_IconTextButtonBlock className={props.className}>
            <S_Icon icon={['fal', props.iconName]} />
            <S_Title>{props.title}</S_Title>
            <S_Subtitle>{props.subtitle}</S_Subtitle>
            {props.buttonText && props.buttonAction && (
                <S_WebButton
                    shadow={EShadows.LIGHT}
                    type={'primary'}
                    text={props.buttonText}
                    onClick={props.buttonAction}
                />
            )}
        </S_IconTextButtonBlock>
    );
};

const S_IconTextButtonBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    color: ${EColors.DARK};
    font-size: 25px;
    margin: 20px 0 15px;
`;

const S_Title = styled.div`
    font-size: 16px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Medium};
    margin: 0 0 8px 0;
`;

const S_Subtitle = styled.div`
    font-size: 15px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Regular};
    line-height: 25px;
`;

const S_WebButton = styled(S_WebButtonSmaller)`
    margin: 15px 0 20px 0;
`;
